/**
 * Business units for Meridian Associates.
 * The law firm is organized into four practice groups; employees belong to one.
 */

export interface BusinessUnit {
  id: string;
  name: string;
}

export const BUSINESS_UNITS = [
  { id: 'bu-litigation', name: 'Litigation' },
  { id: 'bu-corporate', name: 'Corporate' },
  { id: 'bu-ip', name: 'IP & Patents' },
  { id: 'bu-tax', name: 'Tax & Estate' },
] as const satisfies readonly BusinessUnit[];
